import { APIS_MAP, APIS_RAOS_DATA } from "@/constants/apis";
import axios from "axios";
import { ref } from "vue";
import { TOKEN } from '@/constants/labels';
import { showConsoleError } from '@/functions/errors'



export async function getAllRajantRAOSData() {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .get(APIS_RAOS_DATA.value.getAllRajantRAOSData, { headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any>({});
            const showGraphs = ref(finalData.length > 0);
            if (finalData.length > 0) {
                finalData.forEach((item: any) => {
                    if (!finalObj.value[item.ip]) {
                        finalObj.value[item.ip] = {}
                    }

                    const instamesh = JSON.parse(item.instamesh ?? `{}`);
                    const wired = JSON.parse(item.wired ?? `{}`);
                    const wireless = JSON.parse(item.wireless ?? `{}`);


                    finalObj.value[item.ip].instamesh = instamesh
                    finalObj.value[item.ip].wired = wired
                    finalObj.value[item.ip].wireless = wireless
                })
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}


export async function getAllLatenciaRAOSData() {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .get(APIS_RAOS_DATA.value.getAllLatenciaRAOSData, { headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any>({});
            const showGraphs = ref(finalData.length > 0)
            if (finalData.length > 0) {
                finalData.forEach((item: any) => {
                    if (!finalObj.value[item.ip]) {
                        finalObj.value[item.ip] = {}
                    }

                    const latencia = item.latencia

                    finalObj.value[item.ip].latencia = latencia
                })
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}

export async function getAllSensoresRAOSData() {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .get(APIS_RAOS_DATA.value.getAllSensoresRAOSData, { headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any>({});
            const showGraphs = ref(finalData.length > 0)
            if (finalData.length > 0) {
                finalData.forEach((item: any) => {
                    if (!finalObj.value[item.ip]) {
                        finalObj.value[item.ip] = {}
                    }

                    const valores = JSON.parse(item.valores ?? `{"temperature":[0], "voltage":[0]}`);


                    finalObj.value[item.ip].temperatura = valores.temperature
                    finalObj.value[item.ip].voltaje = valores.voltage
                })
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}


export async function getAllRajantRAOSDataBYip() {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .get(APIS_RAOS_DATA.value.getAllRajantRAOSDataBYip, { headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any[]>([])
            const showGraphs = ref(finalData.length > 0)
            if (finalData.length > 0) {
                finalObj.value = finalData
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}


export async function getAllLatenciaRAOSDataBYip() {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .get(APIS_RAOS_DATA.value.getAllLatenciaRAOSDataBYip, { headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any[]>([])
            const showGraphs = ref(finalData.length > 0)
            if (finalData.length > 0) {
                finalObj.value = finalData
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}

export async function getAllSensoresRAOSDataBYip() {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .get(APIS_RAOS_DATA.value.getAllSensoresRAOSDataBYip, { headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any[]>([])
            const showGraphs = ref(finalData.length > 0)
            if (finalData.length > 0) {
                finalObj.value = finalData
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}


export async function getBandWidthData() {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()    
    
    
    await axios.get(APIS_MAP.value.getAllBandWidth,{ headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
        const finalData: any = response.data;
        const finalObj = ref<any[]>([])
        const showGraphs = ref(finalData.length > 0)
        if (finalData.length > 0) {
            finalObj.value = finalData
        }
        statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
        statusAxios.value = { status: 400, data: [], showGraphs: false }
        showConsoleError(error)
    })

    return statusAxios.value
}     